import { useState } from "react";
 import { useNavigate } from "react-router-dom";
import { routerlogin } from "../../../../services/user/UserController";

const RouterLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
 
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await routerlogin(username, password);
            navigate('/dashboard');
        } catch (error) {
            setError('Invalid credentials');
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleLogin}>
                <h2>Login to Juniper 128T</h2>
                {error && <div className="error">{error}</div>}
                <div>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="submit">Login</button>
            </form>
        </div>
    );
};

export default RouterLogin;
